import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { BrandsDto } from './brands.dto';


export class MasterBrandResponse extends GlobalResponseObject {
    data?: BrandsDto;
    
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data MasterBrandDTO[]
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: BrandsDto){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}